import { render, staticRenderFns } from "./Opcoes.vue?vue&type=template&id=0c8580a8&scoped=true"
import script from "./Opcoes.vue?vue&type=script&lang=js"
export * from "./Opcoes.vue?vue&type=script&lang=js"
import style0 from "./Opcoes.vue?vue&type=style&index=0&id=0c8580a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8580a8",
  null
  
)

export default component.exports